<template>
  <div class="Custom container h-100">
    <div class="content">
      <div class="header" style="text-align: left">
        <div class="block" style="padding-top:10px;height: 100%">
          <div>
            <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="消息通知(未读)" name="unread">
                <div slot="label">
                  <el-badge :value="summary.unread" :max="99" class="item">
                    <el-link :underline="false" size="small" :title="summary.unread">消息通知-未读</el-link>
                  </el-badge>
                </div>
                <div>
                  <NotifyList ref="notify_unread" :type="`unread`" @readCallback="readCallback"></NotifyList>
                </div>
              </el-tab-pane>
              <el-tab-pane label="消息通知(已读)" name="read">
                <div slot="label">
                  <el-link :underline="false" size="small" :title="summary.read">消息通知-已读</el-link>
                </div>
                <div>
                  <NotifyList ref="notify_read" :type="`read`" @readCallback="readCallback"></NotifyList>
                </div>
              </el-tab-pane>
              <el-tab-pane label="消息通知(全选)" name="all">
                <div slot="label">
                  <el-link :underline="false" size="small" :title="`${summary.read + summary.unread}`">消息通知-全部</el-link>
                </div>
                <div>
                  <NotifyList ref="notify_all" :type="`all`" @readCallback="readCallback"></NotifyList>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotifyList from "@/views/notify/components/NotifyList";
import {summaryNotify} from "@/api/notify";

export default {
  name: "index",
  components: {
    NotifyList
  },
  data() {
    return {
      tabPosition: 'left',
      activeName: 'unread',
      loading: false,
      summary: {read: 0, unread: 0},
      searchCondition: {is_read: 'N'},
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 50
      },
    }
  },
  created() {
    this.getSummaryNotify()
  },
  mounted() {
    this.activeName = 'unread'
    this.$refs.notify_unread.init()
  },
  methods: {
    // tab切换
    handleClick(tab) {
      switch (tab.name) {
        case 'unread':
          this.searchCondition.is_read = 'N';
          this.$nextTick(() => {
            this.$refs.notify_unread.init()
          })
          break
        case 'read':
          this.searchCondition.is_read = 'Y';
          this.$nextTick(() => {
            this.$refs.notify_read.init()
          })
          break
        case 'all':
          this.searchCondition.is_read = null;
          this.$nextTick(() => {
            this.$refs.notify_all.init()
          })
          break
      }
    },
    getSummaryNotify() {
      summaryNotify().then((res) => {
        if (res.model) {
          this.summary = res.model.summary
        }
      })
    },
    readCallback() {
      this.summary.read += 1
      this.summary.unread -= 1
    }
  }
}
</script>

<style scoped>
.block {
  max-width: 1400px;
  margin: auto;
}

.notify-message::before {
  content: '内容：';
  color: #9F9F9F;
}

.item {
  margin-top: 10px;
  margin-right: 10px;
}
</style>